<template>

    <div id="signup">

        <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">

            <div class="mt-8 sm:mx-auto w-full sm:w-4/6" >

                <div v-if="loaded" class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">

                    <div v-if="signed_up" class="text-center">

                        <h1 class="mb-6 font-medium text-3xl text-gray-900">Thank you</h1>

                        <div>
                            <p>
                                Thank you for signing up, we have received your application which can take up to 72 hours
                                to be approved. Once approved you will be sent an email containing your account password.
                            </p>
                        </div>

                        <div class="mt-6">
                            <router-link :to="{ name: 'login' }">Back to Log In</router-link>
                        </div>

                    </div>
                    <div v-else>
                        <h1 class="mb-6 font-medium text-3xl text-gray-900">{{ app_name }}</h1>

                        <div>
                            <h3 class="text-lg leading-6 font-medium text-gray-900">
                                Sign Up
                            </h3>
                            <p class="mt-1 max-w-2xl text-sm text-gray-500">
                                Apply for a {{ app_name }} Account, application process can take up to 72 hours.
                            </p>
                        </div>

                        <form action="#" method="POST" @submit.prevent="signUp">

                            <div class="mt-6 sm:mt-5 space-y-6 sm:space-y-5">

                                <div class="mb-4 flex border-l-4 border-error-500 bg-error-50 text-gray-700 px-4 py-2 rounded tracking-wide shadow items-center text-error-400" v-if="form.hasError()">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                    <p class="text-error-700 text-sm">
                                        {{ form.getErrorMessage() }}
                                    </p>
                                </div>

                                <div class="grid grid-cols-6 gap-6">
                                    <div class="form-control col-span-6 sm:col-span-3" :class="{ 'form-control-error': form.fieldHasErrors('first_name') }">
                                        <label for="first_name">First name<i></i></label>
                                        <input type="text" name="first_name" id="first_name" autocomplete="given-name" v-model="form.data.first_name">
                                        <span v-if="form.fieldHasErrors('first_name')">{{ form.getFieldError('first_name') }}</span>
                                    </div>

                                    <div class="form-control col-span-6 sm:col-span-3" :class="{ 'form-control-error': form.fieldHasErrors('last_name') }">
                                        <label for="last_name">Last name<i></i></label>
                                        <input type="text" name="last_name" id="last_name" autocomplete="family-name" v-model="form.data.last_name">
                                        <span v-if="form.fieldHasErrors('last_name')">{{ form.getFieldError('last_name') }}</span>
                                    </div>

                                    <div class="form-control col-span-6" :class="{ 'form-control-error': form.fieldHasErrors('email') }">
                                        <label for="email_address" class="block text-sm font-medium text-gray-700">Email address<i></i></label>
                                        <input type="email" name="email" id="email_address" autocomplete="email-address" v-model="form.data.email">
                                        <span v-if="form.fieldHasErrors('email')">{{ form.getFieldError('email') }}</span>
                                    </div>

                                    <p class="flex col-span-6 -mt-4 text-sm text-gray-500">
                                        Once your account has been approved, you will receive a confirmation email along with a temporary account password.
                                    </p>

                                    <div class="form-control col-span-6" :class="{ 'form-control-error': form.fieldHasErrors('company') }">
                                        <label for="company" class="block text-sm font-medium text-gray-700">Company/Organisation</label>
                                        <input type="text" name="company" id="company" autocomplete="company" v-model="form.data.company">
                                        <span v-if="form.fieldHasErrors('company')">{{ form.getFieldError('company') }}</span>
                                    </div>

                                    <p class="flex col-span-6 -mt-4 text-sm text-gray-500">
                                        Your company/organisation will be setup as an account, once logged in you can invite other users to join your account.
                                    </p>

                                    <div class="form-control col-span-6" :class="{ 'form-control-error': form.fieldHasErrors('interested_brands') }">
                                        <label for="interested_brands" class="block text-sm font-medium text-gray-700">Prefered Brands</label>
                                        <textarea type="text" name="interested_brands" id="interested_brands" autocomplete="interested_brands" v-model="form.data.interested_brands" class="resize-none border rounded-md"></textarea>
                                        <span v-if="form.fieldHasErrors('interested_brands')">{{ form.getFieldError('interested_brands') }}</span>
                                    </div>

                                    <p class="flex col-span-6 -mt-4 text-sm text-gray-500">
                                        What brands are you interested in purchasing through Simfoni Retail?
                                    </p>

                                    <div class="col-span-6">
                                        <div class="flex items-center">
                                            <input id="marketing" name="marketing" type="checkbox" class="h-4 w-4 text-brand-500 focus:ring-brand-500 border-gray-300 rounded" v-model="form.data.marketing">
                                            <label for="marketing" class="ml-2 block text-sm text-gray-900">
                                                Receive new offers by email?
                                            </label>
                                        </div>
                                    </div>

                                    <div class="col-span-6">
                                        <div class="flex items-center" :class="{ 'form-control-error': form.fieldHasErrors('terms') }">
                                            <input id="terms_checkbox" name="terms" type="checkbox" class="h-4 w-4 text-brand-500 focus:ring-brand-500 border-gray-300 rounded" v-model="form.data.terms">
                                            <label for="terms_checkbox" class="ml-2 block text-sm text-gray-900">
                                                I agree to the <router-link :to="{ name: 'terms' }">Terms</router-link> and <router-link :to="{ name: 'privacy' }">Privacy Policy</router-link>
                                            </label>

                                            <span class="ml-4 -mt-4" v-if="form.fieldHasErrors('terms')">{{ form.getFieldError('terms') }}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="mt-6">
                                <button type="submit" class="btn justify-center px-12">
                                    Sign Up
                                </button>
                            </div>

                        </form>


                        <div class="mt-4 font-medium">
                            <p>
                                Already have an account? <router-link :to="{ name: 'login' }">Log In</router-link>
                            </p>
                        </div>
                    </div>

                </div>
                <Loading v-else></Loading>

                <div class="text-center w-full text-xs text-gray-400 mt-2">
                    <p class="mt-4">{{ app_name }} {{ version }} &copy; <a :href="copyright.url" class="text-brand-400" target="_blank">{{ copyright.name }}</a></p>
                    <p class="my-2">Unauthorised access is not permitted. <a :href="status_uri" class="text-brand-400" target="_blank" v-if="status_uri">System Status</a></p>
                </div>

            </div>

        </div>

    </div>

</template>

<script>
import {User} from "../../app/Auth/User";
import Loading from "../Support/Loading";

export default {
    name: "SignUp",
    props: {
        app_name: {
            type: String,
            required: false
        },
        version: {
            type: String,
            required: false
        },
        status_uri: {
            type: String,
            required: false
        },
        copyright: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            form: null,
            loaded: false,
            signed_up: false,
        }
    },
    components: {
        Loading
    },
    methods: {
        signUp() {
            let vm = this;

            vm.form.resetErrors();

            vm.form.signUp().then(response => {
                vm.signed_up = true;
            });
        }
    },
    mounted() {
        let vm = this;
        new Promise(resolve => {
            vm.form = new User();
            resolve(true);
        }).then(result => {
            vm.loaded = result;
        });
    }
}
</script>


